import { SearchConfig, SearchKey } from "../../../../types/search";

type OptionKeys = Extract<
  SearchKey,
  "unitCode" | "name" | "property" | "propertyAdmin" | "businessUnitId" | "ownerName" | "recordNumber"
>;

export const searchByOptions: SearchConfig<OptionKeys>[] = [
  { value: "unitCode", label: "Unit Code", controlType: "text", default: true },
  { value: "name", label: "Name", controlType: "text" },
  { value: "property", label: "Property", controlType: "text" },
  { value: "propertyAdmin", label: "Property Admin", controlType: "select" },
  { value: "businessUnitId", label: "Business Unit", controlType: "select" },
  { value: "ownerName", label: "Owner", controlType: "select" },
  { value: "recordNumber", label: "ID", controlType: "text" },
];
